module.exports = __webpack_public_path__ + "img/小狗-3.0bfd5ebd.jpg";